module.exports = __webpack_public_path__ + "static/play-bdcdfa5e7485ce6fa717dc076433f510.png";